<template>
    <div class="tab-group" :style="{width: tabWidth + 'px;'}">
      <slot></slot>
      <!-- <span class="tab-btn" :class="{'tab-btn-active tab-lf-brd': tabCurrent === index || tabCurrent === 0 }" 
        v-for="(item, index) in tabList"
        :key="index"
        @click="toggleTab(0)">{{item.name}}</span> -->
    </div>
</template>

<script>
export default {
  name: "ComTab",
  provide(){
    return {
      tabCurrent: 0,
    }
  },
  props:{
    tabWidth: {
      type: Number
    }
    // tabList: {
    //   type: Array,
    //   default: []
    // }
  },
  methods: {
    toggleTab(id, index) {
      this.tabCurrent = index;
      this.$emit('getTabId', id);
    }
  }
}
</script>

<style lang="scss">
// .tab-group{
//   // width: 320px;
//   min-width: 160px;
//   height: 38px;
//   background: #fff;
//   border: 1px solid #D8E0F0;
//   border-radius: 10px;
//   cursor: pointer;
//   margin: 0 16px;
//   display: inline-block;
//   // @include flex();
//   .tab-btn{
//     min-width: 81px;
//     height: 38px;
//     line-height: 38px;
//     padding: 0 14px;
//     font-size: 14px;
//     color: #7D8592;
//     display: inline-block;
//     text-align: center;
//     border-right: 1px solid #D8E0F0;
//      &:first-child{
//       border-radius: 10px 0 0 10px;
//     }
//     &:last-child{
//       border-right: 0px;
//       border-radius: 0 10px 10px 0;
//     }
//   }
//   .tab-btn-active{
//     background: #67B4C4;
//     color: #FFF;
//   }
// }

.tab-group{
  height: 40px;
  background: #fff;
  border-radius: 10px;
  cursor: pointer;
  margin: 0 16px;
  display: inline-block;
  overflow: hidden;
  .tab-btn{
    height: 40px;
    line-height: 39px;
    padding: 0 14px;
    font-size: 14px;
    color: #7D8592;
    display: inline-block;
    text-align: center;
    border: 1px solid #D8E0F0;
    border-left: 0;
    &:first-child{
      border-radius: 10px 0 0 10px;
      border-left: 1px solid #D8E0F0;
    }
    &:last-child{
      border-radius: 0 10px 10px 0;
    }
  }
  .search-tab-btn{
    width: 48px;
    color: #222;
    padding: 0;
  }
  .tab-btn-active{
    background: #67B4C4;
    color: #FFF;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Tab.vue